import { Navigate,useLocation } from "react-router";
// Keep existing bookmarks and notification links working without a second task interface.
export function MyTasksPage(){const {search}=useLocation();return <Navigate replace to={`/tasks${search}`}/>;}
